export default {
  mutations: {
    SET_LIQUIDATIONS: '  SET_LIQUIDATIONS',
    SET_SINGLE_LIQUIDATION: 'SET_SINGLE_LIQUIDATION',
    SET_LIQUIDATION_PAGINATION: 'SET_LIQUIDATION_PAGINATION',
    SET_LIQUIDATION_KIND_LIST: 'SET_LIQUIDATION_KIND_LIST',
  },
  getters: {
    GET_LIQUIDATIONS: 'GET_LIQUIDATIONS',
    GET_SINGLE_LIQUIDATION: 'GET_SINGLE_LIQUIDATION',
    GET_LIQUIDATION_KIND_LIST: 'GET_LIQUIDATION_KIND_LIST',
  },
  actions: {
    SAVE_LIQUIDATION: 'SAVE_LIQUIDATION',
    LIQUIDATION_LIST: 'LIQUIDATION_LIST',
    LIQUIDATION_KIND_LIST: 'LIQUIDATION_KIND_LIST',
    SINGLE_LIQUIDATION: 'SINGLE_LIQUIDATION',
  },
};
